import React, { useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import Navbar from '../NavBar/Navbar';
import MapDashboard from '../myproporties/MapDashboard';
import FadeLoader from "react-spinners/FadeLoader";
import { FcCancel } from "react-icons/fc";
import StatusDropdown from '../MyWorklist/StatusDropdown'
import { BiSortAlt2 } from "react-icons/bi";
import Popover from '@mui/material/Popover';

import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook

const ViewPrakingLotInfo = (EmailId) => {
    const [anchorEl, setAnchorEl] = useState(null);  // State to track anchor element for the popup
    const [selectedRowData, setSelectedRowData] = useState(null);
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
    const [filter, setFilter] = useState([]);
    const [search, setSearch] = useState("");
    const [, setPopupVisible] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [rowData, setRowData] = useState([]);
    const [areasmarked, setAreasmarked] = useState([]);
    const [isEdit, setEdit] = useState();
    const [parkinglotObj, setparkinglotObj] = useState();
    const [loader, setLoader] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(''); // This will store the selected status
    const [sortDirection, setSortDirection] = useState('asc'); // State for sorting direction
    const [editOption, setEditoption] = useState();
    const [addProperty, setAddproperty] = useState(false);
    const [mapVisibleChanges, setMapVisibleChanges] = useState(false);
    const { userDetails, employeeData } = useUser();
    const [userData] = useState(userDetails);
    // const [empData] = useState(employeeData);
    const [apiCalled, setApiCalled] = useState(false);
    const [defaultaddress, setDefaultaddress] = useState("");
const [entityId, setEntityId] = useState(null);
const [empRegistrationId,setEmpRegistrationId] =useState(null)
  const [isEmployee, setIsEmployee] = useState(false);


    const fetchParkinglotDetails = async (id) => {
        if (!id) {
            console.warn("Missing EntityRegistrationID.");
            return;
        }
        setLoader(true);
        setApiCalled(false);

       try {
            const bodyData = isEmployee
                ? { EmpRegistrationID: id }
                : { EntityRegistrationID: id };
            const response = await fetch(`${hostPath}/api/ParkingLotBookingDetailsbyId`, {
                method: "POST",
                headers: {
                    "x-functions-key": hostHeader,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(bodyData),
            });


            if (!response.ok) {
                if (response.status === 404) {
                    setParkingLotBookingDetails([]);
                    return;
                }
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            setParkingLotBookingDetails(data);
            setApiCalled(true);
        } catch (error) {
            console.error("Failed to fetch parking lot details:", error);
            setParkingLotBookingDetails([]);
        } finally {
            setLoader(false);
        }
    };
  useEffect(() => {
  console.log("userDetails1111111111111", userDetails);

  if (userDetails) {
    setDefaultaddress(userDetails.enityMailingAdderess);
    setEntityId(userDetails.entityRegistrationID);
    setIsEmployee(false)
  } else if (employeeData) {
    setIsEmployee(true)
    setDefaultaddress(employeeData.enityMailingAdderess);
    setEntityId(employeeData.entityRegistrationID);
        setEmpRegistrationId(employeeData.empRegistrationID)

  }
}, [userDetails, employeeData]);

   useEffect(() => {
  if (isEmployee && empRegistrationId) {
    fetchParkinglotDetails(empRegistrationId);
  } else if (!isEmployee && entityId) {
    fetchParkinglotDetails(entityId);
  }
}, [isEmployee, entityId, empRegistrationId, hostPath]);

    useEffect(() => {
        let result = parkingLotBookingDetails;

        // Filter by search query
        if (search) {
            result = result.filter((item) => {
                return (item.parkingLotAddress || item.createdDate || item.nickName).toLowerCase().includes(search.toLowerCase());
            });
        }
        // Filter by selected status
        if (selectedStatus.length > 0) {
            result = result.filter((item) => selectedStatus.includes(item.status));
        }
        setFilter(result);
    }, [search, parkingLotBookingDetails, selectedStatus]);
    const handleDelete = (val, typeOfButton) => {
        let message;
        let message2;
        let status;
        if (typeOfButton === 'trash') {
            message = 'Are you sure you want to delete this property? This action is irreversible.';
            message2 = 'Once you proceed, you will not be able to undo this action. Please confirm if you wish to continue.'
            status = 'delete';
        } else if (typeOfButton === 'cancel') {
            message = 'Are you sure you want to mark this property as inactive?';
            message2 = 'You can make it active again in the future if you wish. Please confirm if you wish to continue.'
            status = 'Inactive'
        }
        else if (typeOfButton === 'active') {
            message = 'Are you sure you want to mark this property as active?';
            message2 = 'Please confirm if you wish to continue.'
            status = 'Submitted'
        }

        let data = { EmailId: val.emailId, Parking_Lot_ID: val.parking_Lot_ID, message, message2, status, val };
        setRowData(data);
        setOpen(true);
        setPopupVisible(false);
    };
    const handleConfirm = (text, status, val) => {

        if (text === 'confirm') {

            if (status === 'delete') {
                const requestOptions = {
                    method: 'POST',
                    headers: { "x-functions-key": hostHeader },
                    body: JSON.stringify(rowData)
                };
                setLoader(true);

                axios.post(`${hostPath}/api/DeleteParkingLotDetailsByEmailId`, requestOptions.body, { headers: requestOptions.headers })
                    .then(response => {
                        if (response.data) {
                            if (response.data.status) {
                                const newdata = parkingLotBookingDetails.filter((item) => item.parking_Lot_ID !== rowData.Parking_Lot_ID);
                                setParkingLotBookingDetails(newdata);
                                setFilter(newdata);
                                setOpen(false);
                            }
                            else {
                                alert(response.data.responseMessage);
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    })
                    .finally(() => {
                        setLoader(false);
                    })
            }
            else if (status === 'Inactive' || status === 'Submitted') {
                let statusval = status;
                if (status === 'Submitted') {
                    if (val?.verifyStatus === "Active" || val?.verifyStatus === "Rejected") {
                        statusval = val?.verifyStatus
                    }
                }
                const CoardinateDetails = val?.coardinateDetails;
                const Scheduleavailability = val?.scheduleavailability
                const parkinglot = {
                    "EmailId": val.emailId,
                    "EntityRegistrationID": val?.entityRegistrationID,
                    "ParkingLotAddress": val?.parkingLotAddress,
                    "Parking_Lot_ID": val?.parking_Lot_ID,
                    "id": val?.id,
                    "CreatedDate": val?.createdDate,
                    "Status": statusval,
                    "Comment": val?.comment,
                    "StreetName": val?.streetName,
                    "VerifyStatus": val?.verifyStatus,
                    "BankDetailID": val?.bankDetailID,
                    "Nickname": val?.nickName,
                    CoardinateDetails,
                    Scheduleavailability
                };
                axios.post(`${hostPath}/api/UpdateParkingLotDetails`, parkinglot, {
                    headers: {
                        "x-functions-key": hostHeader
                    }
                })
                    .then(response => {
                        if (response.data) {
                            fetchParkinglotDetails();
                            setOpen(false);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            }
        }
        else if (text === 'cancel') {
            setOpen(false);
        }
    };

    const handleEdit = (e, val) => {
        setSelectedRowData(val);
        setAnchorEl(e.currentTarget);  // Set the clicked element as the anchor for the popup
    };

const handleEdittomap = (val) => {
    setparkinglotObj(val);
    setDefaultaddress(val?.parkingLotAddress);
    
    const transformedAreas = val?.coardinateDetails?.map(details => ({
        Coordinates: {
            Title: details?.title || 'Unknown',
            Latitude: parseFloat(details?.latitude) || 0,
            Longitude: parseFloat(details?.longitude) || 0,
            ScheduleAvailability: details?.scheduleavailability || []
        },
        Name: details?.title || 'Unknown',
        id: parseInt(details?.id, 10) || 0,
        VehicleSpotSize: details?.vechileSpotSize || '',
        pslName: details?.pslName || '',
        groupName: Array.isArray(details?.groupName) 
            ? (details.groupName[0] || 'Default') 
            : (details?.groupName || 'Default'),
        latandlong: `Latitude: ${parseFloat(details?.latitude) || 0} Longitude: ${parseFloat(details?.longitude) || 0}`,        
    }));
    
    setAreasmarked(transformedAreas);
    setEdit(true);
    setPopupVisible(false);
};

    const handleStatusChange = (selectedStatus) => {
        setSelectedStatus(selectedStatus);
    };
    const handleSort = (column) => {
        // Toggle the sorting direction
        const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newSortDirection);

        // Sort the data based on the 'createdDate' field
        const sortedData = [...filter].sort((a, b) => {
            const dateA = new Date(a[column]);
            const dateB = new Date(b[column]);

            if (newSortDirection === 'asc') {
                return dateA - dateB;
            } else {
                return dateB - dateA;
            }
        });

        setFilter(sortedData);
    };
    const columns = [
        {
            name: "Nickname",
            selector: (row) => row.nickName,
        },
        {
            name: "Street Address",
            cell: (row) => (
                <div
                    style={{ cursor: 'pointer' }}  // Style to indicate it's clickable
                    onClick={(e) => handleEdittomap(row)} // Call function when clicked
                >
                    {row.parkingLotAddress}
                </div>
            ),
        },
        {
            name: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                    Parking Spaces Selected
                </div>
            ),
            selector: (row) =>
                row?.coardinateDetails?.filter((coord) => coord.title === "PSL - Parking Space Location").length || 0,
            grow: 1,
            wrap: true,
        },
        {
            name: (
                <div style={{ whiteSpace: "normal", textAlign: "center" }}>
                   Created By
                </div>
            ),
            selector: (row) =>row?.createdBy,
        },

        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort('createdDate')}>
                    Created Date <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.createdDate,
        },
        {
            name: (
                <div style={{ display: 'flex', alignItems: 'center' }} onClick={() => handleSort("lastUpdatedDate")}>
                    Last Updated <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.lastUpdatedDate,
        },
        {
            name: (
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <StatusDropdown handleStatusChange={handleStatusChange} />
                </div>
            ),
            selector: (row) => row?.status,
        },
        {
            name: "Actions",
            cell: (row) => (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '0px' }}>
                    {row.status === 'Inactive' ? (
                        <>
                            {/* Show "Activate" icon for inactive status */}
                            <FiEdit3 title="Activate" aria-label="Activate"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                    color: "green"
                                }}
                                onClick={() => handleDelete(row, 'active')}  // Change status to Active
                            />
                        </>
                    ) : (
                        <>
                            {/* Show default edit and delete icons for active status */}
                            <FiEdit3 title="Edit" aria-label="Edit"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                }}
                                onClick={(e) => handleEdit(e, row)} />
                            <FiTrash2 title="Delete" aria-label="Delete"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: "pointer",
                                    justifyContent: "center",
                                }}
                                onClick={() => handleDelete(row, 'trash')}  // Pass 'trash' as the type
                            />
                            <FcCancel
                                title={row.status === 'Active' ? 'Inactive' : 'Disabled'}
                                aria-label="Inactive"
                                style={{
                                    width: "38px",
                                    height: "25px",
                                    padding: "2px 2px",
                                    cursor: row.status === 'Active' ? "pointer" : "not-allowed",
                                    justifyContent: "center",
                                    opacity: row.status === 'Active' ? 1 : 0.5, // visually show it's disabled
                                }}
                                onClick={row.status === 'Active' ? () => handleDelete(row, 'cancel') : null}
                            />

                        </>
                    )}
                </div>
            ),
        },
    ];

    const tableHeaderStyle = {
        headCells: {
            style: {
                height: "90px",
                fontWeight: 800,
                fontSize: "16px",
                backgroundColor: "white",
                lineHeight: "19.2px",
                fontFamily: "Lato",
                textAlign: "left",
                borderBottom: "none"
            },
        },
    };

    const handleClose = () => {
        setAnchorEl(null);  // Close the popup
    };

    const Isopen = Boolean(anchorEl);  // Boolean to check if the popup is open
    const id = Isopen ? 'edit-popover' : undefined;

    const handleOptionClick = (option) => {
        setEditoption(option);
        setAnchorEl(null);  // Close the popup after selecting an option
        handleEdittomap(selectedRowData);
    };
    const handleAddProperty = (val) => {
        setAddproperty(val);
        setEdit(val);
    }
    const handleMapVisibleChanges = (value) => {
        setMapVisibleChanges(value);
    };
    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            <Navbar userData={userData} mapvisible={mapVisibleChanges} setMapvisible={setMapVisibleChanges} />
            {!isEdit ? (

                <div>
                    <div className='container-fluid p-0'>
                        <div className="lotmanagement">
                            <div className="row" style={{ textAlign: "left" }}>
                                <div className="col-8">
                                    <div className='viewHeader'>Registered Parking Lots</div>
                                    <div className='listview'>View the list of parking lots registered</div>
                                    {/* <div style={{ color: 'blue', cursor: 'pointer', marginBottom: '15px', fontSize: '16px' }} onClick={navigateToDashboard}>Sign up more parking lots</div> */}
                                </div>
                            </div>

                            <div className="row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                                {/* Left side: Total parking lots */}
                                <div className="col-6 mb-2" style={{ textAlign: "left" }}>
                                    Total parking lots: {parkingLotBookingDetails.length}
                                </div>
                                {/* Right side: Search input + Add button */}
                                <div className="col-6 mb-2" style={{ textAlign: "right", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px" }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by address."
                                        style={{ maxWidth: "300px" }}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button className="add-property-btn" onClick={() => handleAddProperty(true)}>
                                        Add Property
                                    </button>
                                </div>
                            </div>
                            <React.Fragment>
                                <DataTable
                                    customStyles={{
                                        headCells: tableHeaderStyle.headCells,
                                        cells: {
                                            style: {
                                                fontFamily: 'Lato',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                lineHeight: '18.6px',
                                                textAlign: 'left',
                                                height: "50px",
                                                borderBottom: "none"
                                            },
                                        },
                                    }}
                                    columns={columns}
                                    data={filter.length ? filter : []}  // Pass empty array to prevent row rendering
                                    pagination
                                    fixedHeader
                                    selectableRowsHighlight
                                    highlightOnHover
                                    persistTableHead
                                    noDataComponent={
                                        apiCalled && !loader ? (
                                            <div style={{ padding: '20px 0', textAlign: 'center' }}>
                                                No records found
                                            </div>
                                        ) : null
                                    }

                                />

                            </React.Fragment>
                        </div>
                    </div>
                    <Dialog
                        classes={{ paper: 'custom-paper-class-delete' }}
                        aria-labelledby="customized-dialog-title"
                        dividers
                        open={open}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <DialogTitle dividers sx={{ textAlign: 'start', color: "#000;", fontSize: "24px", fontWeight: "700", padding: "5px 24px " }} id="customized-dialog-title">
                            {rowData?.message}  {/* Display different messages based on the button clicked */}
                        </DialogTitle>
                        <DialogContent style={{ border: "none", padding: "5px 22px", color: "#000;" }}>
                            <Typography gutterBottom>
                                <span>{rowData?.message2}</span>
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'right' }}>
                            <Button
                                className='custom-button-cancel'
                                onClick={() => handleConfirm('cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                className='custom-button-delete'
                                onClick={() => handleConfirm('confirm', rowData?.status, rowData?.val)}
                            >
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Popover
                        id={id}
                        open={Isopen}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'center',
                            horizontal: 'left',  // Popup will appear to the left of the clicked icon
                            height: '500px',
                            width: '500px'
                        }}
                        transformOrigin={{
                            vertical: 'center',
                            horizontal: 'right',  // Popup will align to the right side of the anchor element
                        }}
                    >
                        <div style={{ padding: '10px' }}> {/* Additional padding for content */}
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('parkingspaces')}
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
                            >
                                Parking Spaces
                            </Button>
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('parkingschedule')}
                                disabled={
                                    (selectedRowData?.coardinateDetails?.filter(coord => coord.title === "PSL - Parking Space Location").length || 0) === 0
                                }
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
                            >
                                Parking Schedule
                            </Button>
                            <Button
                                variant="text"
                                onClick={() => handleOptionClick('bankdetails')}
                                disabled={
                                    (selectedRowData?.coardinateDetails?.filter(coord => coord.title === "PSL - Parking Space Location").length || 0) === 0
                                }
                                style={{ display: 'block', textAlign: 'left', width: '100%', textTransform: 'none' }}
                            >
                                Bank Details
                            </Button>
                        </div>
                    </Popover>


                </div>
            ) : (
                !addProperty ? (
                    <div><MapDashboard isEdit={isEdit} areasMarked={areasmarked} defaultaddress={defaultaddress} userData={userDetails} entityId={entityId} employeeData={employeeData} parkinglotObj={parkinglotObj} editOption={editOption} mapVisibleChangesAlert={handleMapVisibleChanges} empRegistrationId={empRegistrationId}  /></div>
                ) : (
                    <div><MapDashboard defaultaddress={defaultaddress} userData={userDetails} entityId={entityId} employeeData={employeeData} mapVisibleChangesAlert={handleMapVisibleChanges} isEmployee={isEmployee} empRegistrationId={empRegistrationId} /></div>
                )
            )}
        </div>
    );
};

export default ViewPrakingLotInfo;
